import styled from 'styled-components';
import { motion } from 'framer-motion';

import { getSpace, getColor, mq } from '../../../../../stylesheets/tools';

const StyledViewSwitch = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: ${getSpace('xxxxs')};

  p {
    display: none;

    ${mq('xl')} {
      display: block;
    }
  }

  svg {
    cursor: pointer;
  }

  path,
  rect {
    transition: fill 0.7s ease;
  }

  .view-switch__item {
    display: flex;
    gap: ${getSpace('xxxs')};
  }

  .view-switch__button--active .view-switch__stack-icon {
    path {
      fill: ${getColor('navGray')};
      transition: fill 0.7s ease-in-out;
    }
  }

  .view-switch__button--active .view-switch__list-icon {
    rect {
      fill: ${getColor('white')};
      transition: fill 0.7s ease-in-out;

      &:first-child {
        fill: ${getColor('navGray')};
      }
    }
  }
`;

export default StyledViewSwitch;
